<template>
  <div v-on:click.self="closeModal" class="modal--wrapper" :class="{'modal-open': opened}">
    <div class="modal address-modal">
      <div class="modal--title">
        <div class="modal--title-text">{{$t('card-payment-modal.addMethod')}}</div>
        <div class="modal--title-actions">
          <modal-close-btn @click="closeModal"/>
        </div>
      </div>
      <div class="modal--content" v-if="!loading">
        <div class="fields">
          <text-input :placeholder="$t('card-payment-modal.cardName')" v-model="cardHolderName" :error-message="cardHolderError" :error="!!cardHolderError" />
        </div>
        <div class="fields error" v-if="!!cardError">{{cardError}}</div>
        <div class="fields" ref="card"></div>
        <div class="fields">
          <cgv-input v-model="accepted" />
          <save-card-input v-model="accepted2" />
        </div>
      </div>
      <div class="modal--content" v-if="loading || !cardInputReady">
        <div class="loader">
          <loader/>
        </div>
      </div>
      <div class="modal--footer" v-if="!loading && cardInputReady">
        <button class="btn btn-primary btn-std modal-btn" @click="submitAddCard"
                :disabled="!cardInputReady || !accepted || !accepted2">{{$t('card-payment-modal.addMyCard')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import loader from '../../../components/loader.component';
  import {mapState} from "vuex";
  import TextInput from "../../../components/text-input";
  import {clientService} from "../../../network/services/client.service";
  import ModalCloseBtn from "../../../components/modal-close-btn";
  import CheckboxInput from "../../../components/checkbox-input";
  import CgvInput from "../../../components/cgv-input";
  import SaveCardInput from "../../../components/save-card-input";
  let stripe = null
  export default {
    name: "add-card-modal",
    components: {CgvInput, SaveCardInput, CheckboxInput, ModalCloseBtn, TextInput, loader},
    computed: mapState({}),
    props: {
      opened: Boolean
    },
    mounted () {
      if (!stripe) {
        try {
          stripe = Stripe(process.env.STRIPE_PK);
        } catch (e) {
          console.error('Stripe not defined');
        }
      }
    },
    beforeDestroy() {
      if (!this.cardElement) {
        return;
      }
      this.cardElement.unmount();
      this.cardElement.destroy();
      this.$refs.card.innerHTML = '';
    },
    data () {
      return {
        loading: false,
        cardInputReady: false,
        cardHolderName: '',
        cardHolderError: null,
        cardElement: null,
        cardError: null,
        accepted: false,
        accepted2: false,
      }
    },
    watch: {
      opened (o) {
        if (o) {
          this.init();
        }
        this.accepted = false;
        this.accepted2 = false;
      }
    },
    methods: {
      async submitAddCard () {
          if (this.cardHolderName.length < 1) {
            this.cardHolderError = this.$t('card-payment-modal.cardHolderError');
            return;
          }
          this.cardInputReady = false;
          const setupIntent = await this.createSetupIntent();
          try {
            const result = await stripe.confirmCardSetup(setupIntent, {
              payment_method: {
                card: this.cardElement,
                billing_details: {
                  name: this.cardHolderName
                }
              }
            });
            if (!result.error) {
              await this.$store.dispatch('stripeCard/attach', result.setupIntent.payment_method);
              this.$emit('close', {success: true});
              this.loading = false;
              return;
            }
            this.cardInputReady = true;
            this.cardError = result.error.message;
          } catch (e) {
            this.cardInputReady = true;
          }
      },
      async createSetupIntent () {
        return this.$store.dispatch('stripeCard/createSetupIntent');
      },
      async init() {
        const elements = stripe.elements();
        if (this.cardElement) {
          this.cardElement.clear();
          this.cardHolderName = "";
          this.cardInputReady = true;
          this.$emit('card-input-ready', true);
          return;
        }
        this.cardElement = elements.create('card', {
          iconStyle: 'solid',
          classes: {
            base: 'form-control',
            invalid: 'errored',
            focus: 'focused'
          }
        });
        this.cardElement.on('ready', () => {
          this.cardInputReady = true;
          this.$emit('card-input-ready', true);
        });
        const el = document.createElement('div');
        this.cardElement.mount(el);
        this.$refs.card.appendChild(el);
      },
      closeModal () {
        this.$emit('close');
        this.cardInputReady = false;
        if (!this.cardElement) {
          return;
        }
        this.cardElement.unmount();
        this.cardElement.destroy();
        this.cardElement = null;
        this.$refs.card.innerHTML = '';
      }
    }
  }
</script>
<style scoped>
  .loader {
    height: 120px;
  }
  .fields {
    margin-top: 1rem;
  }

  @media only screen and (max-width: 768px) {
    .modal--title-actions {
      width: 100%;
      bottom: unset;
      position: absolute;
      top: -6px;
    }
    .modal--title-text {
      width: calc(100% - 45px);
    }
  }

  .btn:disabled {
    opacity: .6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/part/add-card-modal.vue